<template>
    <div class="page">
        <slot name="videoConfig" v-if="videoConfig">
            <video-background
                    overlay="#00000033"
                    :src="videoConfig.srcL"
                    :poster="videoConfig.posterL"
                    :sources="[
                        {src: videoConfig.srcM, poster: videoConfig.posterM, res: 900, autoplay: true},
                        {src: videoConfig.srcS, poster: videoConfig.posterS, res: 638, autoplay: true}
                    ]"
                    style="height: 100vh;">
                <page>
                    <template v-slot:main>
                        <slot name="main"></slot>
                    </template>
                    <template v-slot:stage>
                        <slot name="stage"></slot>
                    </template>
                </page>
                <Footer class="footer"><slot name="footer"></slot></Footer>
            </video-background>
        </slot>
        <section class="novideo-section" style="height: 100vh;" v-else>
            <div class="novideo-content">
                <page>
                    <template v-slot:main>
                        <slot name="main"></slot>
                    </template>
                    <template v-slot:stage>
                        <slot name="stage"></slot>
                    </template>
                </page>
                <Footer class="footer"><slot name="footer"></slot></Footer>
            </div>
        </section>
    </div>
</template>

<script>
    import Footer from '@/components/Footer'
    import Page from '@/components/Page'
    import VideoBackground from 'vue-responsive-video-background-player'

    export default {
        name: 'PageWrapper',
        components: {
            Footer,
            Page,
            VideoBackground
        },
        props: {
            videoConfig: {
                type: Object,
                default: null
            },
        },
    }
</script>

<style>
    .videobg-content {
        overflow-y: auto;
    }
    html, body {
        height: 100%;
        margin: 0;
    }
    .footer,
    .push {
        height: 130px;
    }
    .novideo-section {
        background: none;
        position: relative;
        width: 100%;
        overflow: hidden;
    }
    .novideo-section .novideo-content {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow-y: auto;
    }
</style>
